import { type ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface EntityDetailTabsProps {
  overview: (onOpenHistory: () => void) => ReactNode
  relationships: ReactNode
  sources: ReactNode
  history: ReactNode
}

export function EntityDetailTabs({
  overview,
  relationships,
  sources,
  history,
}: EntityDetailTabsProps) {
  const { t } = useTranslation()
  const [tab, setTab] = useState('overview')
  const keys = history
    ? ['overview', 'relationships', 'sources', 'history']
    : ['overview', 'relationships', 'sources']
  return (
    <Tabs value={tab} onValueChange={setTab} className="min-w-0 gap-4">
      <TabsList variant="line" className="w-full border-b border-border/50">
        {keys.map(key => (
          <TabsTrigger key={key} value={key} className="text-xs">
            {t(`investigations.entityDetail.tabs.${key}`)}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value="overview" className="space-y-4">
        {overview(() => setTab('history'))}
      </TabsContent>
      <TabsContent value="relationships" className="space-y-4">
        {relationships}
      </TabsContent>
      <TabsContent value="sources">{sources}</TabsContent>
      {history && <TabsContent value="history">{history}</TabsContent>}
    </Tabs>
  )
}
